var SitePalette = /** @class */ (function () {
    function SitePalette(siteColors, textPresets) {
        if (siteColors === void 0) { siteColors = []; }
        if (textPresets === void 0) { textPresets = {}; }
        this.siteColors = siteColors;
        this.textPresets = textPresets;
    }
    SitePalette.prototype.resolveFont = function (fontKey) {
        var _a;
        return (_a = this.textPresets[fontKey]) === null || _a === void 0 ? void 0 : _a.fontFamily;
    };
    SitePalette.prototype.resolveColor = function (colorKey) {
        var _a;
        return (_a = this.siteColors.find(function (color) { return color.reference === colorKey; })) === null || _a === void 0 ? void 0 : _a.value;
    };
    return SitePalette;
}());
export { SitePalette };
//# sourceMappingURL=site-palette.js.map